import { Component } from '@angular/core';

@Component({
  selector: 'app-security',
  imports: [],
  templateUrl: './security.component.html',
  styleUrl: './security.component.scss'
})
export class SecurityComponent {

}
